const scrollTop = () => {
  const layoutContents = document.getElementById('layoutContents');
  if (layoutContents) {
    layoutContents.scrollTop = 0;
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export default scrollTop;
